import React, { useEffect } from 'react';

import { removeScriptTag, setScriptTag } from 'src/utils/scriptTagManager';

import type { YandexBlockProps } from './types';
import type { FC } from 'react';

const YandexBlock: FC<YandexBlockProps> = ({ id, className, children }) => {
    const blockId = 'yandex-block-script';
    const slotId = `yandex-${id}-slot`;
    const slotIdDouble = `yandex-${id}-slot-double`;

    function doubleCheck() {
        const scriptOptions = {
            id: slotIdDouble,
            prepend: true,
            async: true,
            inlineScript: `
                if (Ya && Ya.Context && Ya.Context.AdvManager && Ya.Context.AdvManager.render) {
                    Ya.Context.AdvManager.render({
                        "blockId": "${id}",
                        "renderTo": "yandex_rtb_${id}"
                    })

                    console.debug('YA AdvManager', 'doubleCheck', 'render');
                }
            `,
        };

        const bannerContainer = document.getElementById(`yandex_rtb_${id}`);

        if (!bannerContainer || bannerContainer.childNodes.length === 0) {
            setTimeout(() => {
                setScriptTag(scriptOptions);
                console.debug(
                    'YA AdvManager',
                    'doubleCheck',
                    true,
                    bannerContainer?.childNodes?.length,
                    bannerContainer,
                );
            }, 1000);
        } else {
            console.debug('YA AdvManager', 'doubleCheck', false, bannerContainer?.childNodes?.length, bannerContainer);
        }
    }

    useEffect(() => {
        const scriptOptions1 = {
            id: blockId,
            prepend: true,
            async: true,
            src: 'https://yandex.ru/ads/system/context.js',
        };

        const scriptOptions2 = {
            id: slotId,
            prepend: true,
            async: true,
            inlineScript: `
                window.yaContextCb = window.yaContextCb || [];
                window.yaContextCb.push(() => {
                    Ya.Context.AdvManager.render({
                        "blockId": "${id}",
                        "renderTo": "yandex_rtb_${id}"
                    })
                })
            `,
        };

        setScriptTag(scriptOptions1);
        setTimeout(() => {
            setScriptTag(scriptOptions2);

            doubleCheck();
        }, 1000);

        return () => {
            removeScriptTag({ id: blockId });
            removeScriptTag({ id: slotId });
            removeScriptTag({ id: slotIdDouble });
        };
    }, []);

    return (
        <div className={className} id={`yandex_rtb_${id}`}>
            {children}
        </div>
    );
};

export default YandexBlock;
